import { render } from "./bar.vue?vue&type=template&id=55629104&scoped=true"
import script from "./bar.vue?vue&type=script&lang=js"
export * from "./bar.vue?vue&type=script&lang=js"

import "./bar.vue?vue&type=style&index=0&id=55629104&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55629104"]])

export default __exports__